import React, { useEffect, useRef, useState } from "react";
import CompoAccueilLeft from "../component/compoAccueil/compoAccueilLeft";
import { URLPageAccueil, URLimage, UrlPeintureDigital, urlBase } from "../utils/varaibleFetch";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import FetchArticles from "../utils/fetcharticle";



export default function Accueil() {
  const urldigital = "/api/categories/1";
  const urlpeinture = "/api/categories/2";
  const location = useLocation();

  
  const [article, setARticle] = useState({});
  const [popularArticles, setPopularArticles] = useState([]);
  const homeRef = useRef(null);
  const popularRef = useRef(null);
  const { articles: selectionArticles } = FetchArticles(UrlPeintureDigital);
  const { articles: digitalArticles, isLoading: isDigitalLoading } = FetchArticles(UrlPeintureDigital, urldigital);
  const { articles: peintureArticles, isLoading: isPeintureLoading } = FetchArticles(UrlPeintureDigital, urlpeinture);

  useEffect(() => {
    axios
      .get(URLPageAccueil)
      .then((response) => {
        const data = response.data;
        setARticle(data["hydra:member"][0]);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données :", error);
      });
  }, []);

  useEffect(() => {
    const fetchPopularArticles = async () => {
      try {
        const response = await fetch(`${urlBase}/oeuvres/popular`);
        const data = await response.json();
        setPopularArticles(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur lors de la récupération des articles populaires:", error);
      }
    };

    fetchPopularArticles();
  }, []);

  useEffect(() => {
    const homeElement = homeRef.current;

    const scrollToHash = () => {
      if (!location.hash) {
        homeElement?.scrollTo({ top: 0, behavior: "auto" });
        return;
      }

      const targetId = location.hash.slice(1);
      const targetElement = document.getElementById(targetId);
      if (!homeElement || !targetElement) return;

      const targetTop = targetElement.getBoundingClientRect().top - homeElement.getBoundingClientRect().top + homeElement.scrollTop - 24;
      homeElement.scrollTo({ top: targetTop, behavior: "smooth" });
    };

    requestAnimationFrame(scrollToHash);
    const timeoutId = window.setTimeout(scrollToHash, 120);

    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.hash]);

  const scrollCarousel = (ref, direction) => {
    if (!ref.current) return;
    ref.current.scrollBy({
      left: direction * 420,
      behavior: "smooth",
    });
  };

  const getLikesCount = (oeuvre) => Array.isArray(oeuvre.likes) ? oeuvre.likes.length : oeuvre.likes || 0;

  const renderHeart = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
    </svg>
  );

  const renderArrow = (direction) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      {direction === "prev" ? (
        <path d="M19 12H5M12 19l-7-7 7-7" />
      ) : (
        <path d="M5 12h14M12 5l7 7-7 7" />
      )}
    </svg>
  );

  return (
    <div className="home-page" ref={homeRef}>
      <section className="home-page__hero">
        <div className="home-page__intro">
          <p className="home-hero__eyebrow">Artiste peintre urbain</p>
          <h1 className="home-hero__title">
            <span>Urban</span><br />
            <span className="accent-cyan">Art</span>{" "}
            <span className="outline">Gallery</span>
          </h1>
          <div className="home-page__mosaic">
            <CompoAccueilLeft />
          </div>
          <p className="home-page__copy home-hero__subtitle">
            {article.texte}
          </p>
          <div className="home-page__links">
            <Link className="home-hero__cta focus-ring" to="/oeuvres">
              <span>Découvrir les œuvres</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      <section className="home-digital-section" id="digital">
        <div className="home-category-container">
          <div className="home-category-header">
            <span className="home-category-number">01</span>
            <h2 className="home-section-title">
              <Link className="home-section-title__link focus-ring" to="/digital">Digital</Link>
            </h2>
            <div className="home-category-line" />
          </div>
          <div className="home-paint-grid">
            {(isDigitalLoading ? [] : digitalArticles.slice(0, 7)).map((oeuvre, index) => (
              <article className={`home-paint-item ${index === 0 ? "home-paint-item--wide" : ""} ${index === 2 ? "home-paint-item--tall" : ""}`} key={`digital-${oeuvre.id}`}>
                <Link className="home-paint-item__inner focus-ring" to={`/oeuvre/${oeuvre.id}`}>
                  <img src={`${URLimage}/${oeuvre.image}`} alt={oeuvre.name} />
                  <div className="home-paint-item__overlay" />
                  <div className="home-paint-item__info">
                    <h3 className="home-paint-item__title">{oeuvre.name}</h3>
                    <p className="home-paint-item__meta">Digital</p>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="home-paint-section" id="peinture">
        <div className="home-category-container">
          <div className="home-category-header">
            <span className="home-category-number">02</span>
            <h2 className="home-section-title">
              <Link className="home-section-title__link focus-ring" to="/peinture">Peinture</Link>
            </h2>
            <div className="home-category-line" />
          </div>
          <div className="home-paint-grid">
            {(isPeintureLoading ? [] : peintureArticles.slice(0, 7)).map((oeuvre, index) => (
              <article className={`home-paint-item ${index === 0 ? "home-paint-item--wide" : ""} ${index === 2 ? "home-paint-item--tall" : ""}`} key={`peinture-${oeuvre.id}`}>
                <Link className="home-paint-item__inner focus-ring" to={`/oeuvre/${oeuvre.id}`}>
                  <img src={`${URLimage}/${oeuvre.image}`} alt={oeuvre.name} />
                  <div className="home-paint-item__overlay" />
                  <div className="home-paint-item__info">
                    <h3 className="home-paint-item__title">{oeuvre.name}</h3>
                    <p className="home-paint-item__meta">Peinture</p>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="home-popular" id="populaires">
        <div className="home-popular__container">
          <div className="home-popular__header">
            <span className="home-category-number">03</span>
            <h2 className="home-section-title">Œuvres Populaires</h2>
            <div className="home-category-line" />
          </div>

          <div className="home-popular__carousel-wrapper">
            <button className="home-section-nav-btn focus-ring" onClick={() => scrollCarousel(popularRef, -1)} aria-label="Précédent" type="button">
              {renderArrow("prev")}
            </button>
            <div className="home-popular__carousel" ref={popularRef}>
              {(popularArticles.length ? popularArticles : selectionArticles).slice(0, 6).map((oeuvre) => (
                <article className="home-popular__item" key={`popular-${oeuvre.id}`}>
                  <Link className="home-card-link focus-ring" to={`/oeuvre/${oeuvre.id}`}>
                    <div className="home-popular__visual">
                      <img src={`${URLimage}/${oeuvre.image}`} alt={oeuvre.name} />
                      <span className="home-popular__likes">{renderHeart()}{getLikesCount(oeuvre)}</span>
                      <span className="home-popular__label">{oeuvre.name}</span>
                    </div>
                    <div className="home-popular__info">
                      <h3 className="home-popular__item-title">{oeuvre.name}</h3>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
            <button className="home-section-nav-btn focus-ring" onClick={() => scrollCarousel(popularRef, 1)} aria-label="Suivant" type="button">
              {renderArrow("next")}
            </button>
          </div>
        </div>
      </section>

      <section className="home-about" id="about">
        <div className="home-about__container">
          <div className="home-about__visual" id="artiste">
            <div className="home-about__image" aria-label="Portrait de l'artiste">
              <img src="/images/portrait/ChatGPT Image 22 mai 2026, 12_58_15.png" alt="Atelier de peinture de l'artiste NAAT" />
            </div>
            <p className="home-about__quote">"La rue est ma galerie, la ville est ma toile."</p>
          </div>

          <div className="home-about__content">
            <p className="home-about__eyebrow">L'artiste</p>
            <h2 className="home-about__title">NAAT</h2>
            <p className="home-about__text">
              Depuis plus d'une décennie, NAAT transforme les murs gris des métropoles en explosions de couleur et d'émotion. Son travail puise dans l'énergie brute de la rue, capturant l'essence de la vie urbaine à travers des portraits expressionnistes saisissants.
            </p>
            <p className="home-about__text">
              Formé aux Beaux-Arts et forgé par la rue, son style unique mêle techniques académiques et spontanéité du graffiti. Chaque œuvre est une rencontre entre la rigueur du pinceau et la liberté du spray.
            </p>
            <p className="home-about__text">
              Ses fresques monumentales ornent les façades de Paris à Marseille, transformant l'architecture en supports d'expression et les passants en visiteurs de galerie à ciel ouvert.
            </p>
            <p className="home-about__signature">— NAAT</p>
          </div>
        </div>
      </section>

      <section className="home-contact" id="contact">
        <div className="home-contact__container">
          <div className="home-contact__info">
            <h2 className="home-contact__title">
              Parlons<br />
              <span>Projet</span>
            </h2>
            <div className="home-contact__links">
              <a href="mailto:contact@naat-art.com" className="home-contact__link focus-ring">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="M22 6l-10 7L2 6" />
                </svg>
                contact@naat-art.com
              </a>
              <a href="tel:+33623848445" className="home-contact__link focus-ring">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
                06 23 84 84 45
              </a>
              <span className="home-contact__link">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Paris, France
              </span>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
